/* Värmarcenter – väljare för elektriska motorvärmare (Calix)
   Märke -> modell -> motorvariant -> komplett system.
   Data: vc-calix-index.json i butikens filer. */
(function () {
  'use strict';
  var root = document.querySelector('[data-vcx]');
  if (!root) return;

  var IX = null;
  var state = { marke: '', modell: '', rad: null, alt: false, tillval: {} };
  var cache = {};

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var el = {
    sok: $('[data-vcx-sok]'), rensa: $('[data-vcx-rensa]'), forslag: $('[data-vcx-forslag]'),
    marke: $('[data-vcx-marke]'), modell: $('[data-vcx-modell]'),
    motor: $('[data-vcx-motor]'), resultat: $('[data-vcx-resultat]'),
    steg: $$('[data-vcx-steg]')
  };

  var TID = { '1': 'under 1,5 tim', '2': '1,5–2 tim', '3': 'över 2 tim' };
  var ROLL = [
    { i: 4, namn: 'Motorvärmare', kravs: 1 },
    { i: 5, namn: 'Monteringssats', kravs: 1 },
    { i: 6, namn: 'Anslutningssats', kravs: 1 },
    { i: 7, namn: 'Grenledningssats', kravs: 1 },
    { i: 8, namn: 'Värmesköld', kravs: 1 },
    { i: 9, namn: 'Pump', kravs: 1 }
  ];

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function kr(ore) {
    if (ore == null) return '';
    return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 }).format(ore / 100);
  }
  function norm(t) {
    return (t || '').toLowerCase().replace(/[åä]/g, 'a').replace(/ö/g, 'o')
      .replace(/é/g, 'e').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---------- ladda index ---------- */
  fetch(root.dataset.vcxIndex, { cache: 'force-cache' })
    .then(function (r) { return r.json(); })
    .then(function (j) { IX = j; start(); })
    .catch(function () {
      el.resultat.innerHTML = '<div class="vcx-tom"><h3>Sökningen kunde inte laddas</h3>' +
        '<p>Ladda om sidan eller <a href="/pages/contact">kontakta oss</a> så hjälper vi dig direkt.</p></div>';
      el.resultat.dataset.open = '1';
    });

  function start() {
    fyllMarken();
    bindSok();
    el.marke.addEventListener('change', function () {
      state.marke = el.marke.value; state.modell = ''; state.rad = null;
      fyllModeller(); fyllMotorer(); rita();
    });
    el.modell.addEventListener('change', function () {
      state.modell = el.modell.value; state.rad = null;
      fyllMotorer(); rita();
    });
    el.motor.addEventListener('change', function () {
      var rader = motorer();
      state.rad = rader[el.motor.value] || null;
      state.alt = false; state.tillval = {};
      rita();
    });
    frånLank();
  }

  function fyll(sel, lista, platshallare, varden) {
    sel.innerHTML = '<option value="">' + esc(platshallare) + '</option>' +
      lista.map(function (t, n) {
        return '<option value="' + esc(varden ? n : t) + '">' + esc(t) + '</option>';
      }).join('');
    sel.disabled = !lista.length;
  }

  function fyllMarken() {
    var m = Object.keys(IX.B).sort(function (a, b) { return a.localeCompare(b, 'sv'); });
    fyll(el.marke, m, 'Välj märke');
    el.marke.disabled = false;
    fyll(el.modell, [], 'Välj modell');
    fyll(el.motor, [], 'Välj motor');
  }
  function fyllModeller() {
    var mo = state.marke ? Object.keys(IX.B[state.marke] || {}) : [];
    mo.sort(function (a, b) { return a.localeCompare(b, 'sv', { numeric: true }); });
    fyll(el.modell, mo, mo.length ? 'Välj modell' : 'Ingen modell registrerad');
  }
  function motorer() {
    if (!state.marke || !state.modell) return [];
    var r = ((IX.B[state.marke] || {})[state.modell] || []).slice();
    r.sort(function (a, b) {
      var ja = parseInt((a[1] || '').slice(0, 4), 10) || 0;
      var jb = parseInt((b[1] || '').slice(0, 4), 10) || 0;
      if (ja !== jb) return jb - ja;
      return (a[0] || '').localeCompare(b[0] || '', 'sv');
    });
    return r;
  }
  function motorTxt(r) {
    var d = [r[0] || ''];
    if (r[1]) d.push(r[1]);
    if (r[2]) d.push('motorkod ' + r[2]);
    return d.join(' · ');
  }
  function fyllMotorer() {
    var r = motorer();
    fyll(el.motor, r.map(motorTxt), r.length ? 'Välj motor och årsmodell' : 'Välj modell först', true);
  }

  /* ---------- sökrutan ---------- */
  var SOK = null;
  function sokBas() {
    if (SOK) return SOK;
    SOK = [];
    Object.keys(IX.B).forEach(function (mk) {
      Object.keys(IX.B[mk]).forEach(function (mo) {
        SOK.push({ mk: mk, mo: mo, h: norm(mk + ' ' + mo) });
      });
    });
    return SOK;
  }
  function bindSok() {
    var t;
    el.sok.addEventListener('input', function () {
      clearTimeout(t); t = setTimeout(forslag, 110);
      el.rensa.style.display = el.sok.value ? '' : 'none';
    });
    el.rensa.addEventListener('click', function () {
      el.sok.value = ''; el.rensa.style.display = 'none'; stang(); el.sok.focus();
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) stang(); });
  }
  function stang() { el.forslag.dataset.open = '0'; el.forslag.innerHTML = ''; }
  function forslag() {
    var q = norm(el.sok.value);
    if (q.length < 2) return stang();
    var ord = q.split(' ');
    var tr = sokBas().filter(function (x) {
      for (var i = 0; i < ord.length; i++) if (x.h.indexOf(ord[i]) === -1) return false;
      return true;
    }).slice(0, 40);
    if (!tr.length) {
      el.forslag.innerHTML = '<div class="vcx-ingen">Ingen träff. Prova märke och modell, t.ex. <b>Volvo XC60</b>.</div>';
      el.forslag.dataset.open = '1'; return;
    }
    el.forslag.innerHTML = tr.map(function (x) {
      return '<button type="button" data-mk="' + esc(x.mk) + '" data-mo="' + esc(x.mo) + '">' +
        '<span class="mk">' + esc(x.mk) + '</span><span>' + esc(x.mo) + '</span></button>';
    }).join('');
    el.forslag.dataset.open = '1';
    $$('button', el.forslag).forEach(function (b) {
      b.addEventListener('click', function () {
        state.marke = b.dataset.mk; state.modell = b.dataset.mo; state.rad = null;
        el.marke.value = state.marke; fyllModeller();
        el.modell.value = state.modell; fyllMotorer();
        el.sok.value = state.marke + ' ' + state.modell;
        stang(); rita();
        el.motor.focus();
      });
    });
  }

  /* ---------- produktdata ---------- */
  function produkt(i) {
    if (i == null || i < 0 || !IX.P[i]) return null;
    var p = IX.P[i];
    return { handle: p[0], titel: p[1], art: p[2], aktiv: !!p[3],
             pdf: p[4] ? (IX.FB || '') + p[4] : '',
             kort: p[5] || '', rader: p[6] || [], brod: p[7] || '',
             ersatter: p[8] || null };
  }
  function hamta(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return null;
        var v = (d.variants || []).filter(function (x) { return x.available; })[0] || d.variants[0];
        cache[handle] = { pris: d.price, id: v && v.id, finns: !!(v && v.available), titel: d.title };
        return cache[handle];
      })
      .catch(function () { return null; });
  }

  /* ---------- rendering ---------- */
  function steg(n) {
    el.steg.forEach(function (s, i) {
      s.setAttribute('aria-current', String(i === n));
      s.dataset.klar = i < n ? '1' : '0';
    });
  }

  function delar(r) {
    var bas = state.alt && r[12] ? r[12] : null;
    var ut = [];
    ROLL.forEach(function (roll, n) {
      var i = bas ? bas[n] : r[roll.i];
      var p = produkt(i);
      if (p) ut.push({ roll: roll.namn, p: p, kravs: true });
    });
    return ut;
  }
  function montAlt(r) { var b = state.alt && r[12] ? r[12] : null; return b ? b[6] : r[10]; }
  function placering(r) {
    var b = state.alt && r[12] ? r[12] : null;
    var i = b ? b[7] : r[11];
    return (i != null && i >= 0 && IX.PL[i]) ? IX.PL[i] : '';
  }

  function infokort(p) {
    if (!p.brod && !(p.rader && p.rader.length)) return '';
    var h = '<span class="vcx-kort" data-vcx-kort>' +
      '<span class="vcx-kort__rub">' + esc(p.titel) + '</span>';
    if (p.brod) h += '<span class="vcx-kort__brod">' + esc(p.brod) + '</span>';
    if (p.rader && p.rader.length) {
      h += '<span class="vcx-kort__data">' + p.rader.map(function (r) {
        return '<span><b>' + esc(r[0]) + '</b>' + esc(r[1]) + '</span>';
      }).join('') + '</span>';
    }
    return h + '</span>';
  }

  function kort(d, n, vald, markering) {
    var p = d.p;
    var saknas = !p.handle || !p.aktiv;
    var ik = infokort(p);
    return '<label class="vcx-del' + (saknas ? ' vcx-del--saknas' : '') + '" data-handle="' + esc(p.handle) + '" data-roll="' + esc(d.roll) + '"' +
      (p.ersatter ? ' data-ersatter="' + esc(p.ersatter.join('|')) + '"' : '') + '>' +
      '<input type="checkbox" data-vcx-del="' + n + '"' + (vald ? ' checked' : '') + (saknas ? ' disabled' : '') + '>' +
      '<span class="vcx-del__kropp">' +
        '<span class="vcx-del__roll">' + esc(d.roll) + (markering ? '<span class="vcx-krav">' + markering + '</span>' : '') + '</span>' +
        '<span class="vcx-del__rad">' +
          '<span class="vcx-del__titel" data-titel>' + esc(p.titel) + '</span>' +
          (ik ? '<button type="button" class="vcx-i" data-vcx-i aria-label="Mer om ' + esc(p.titel) + '">i</button>' : '') +
        '</span>' +
        (p.kort ? '<span class="vcx-del__info">' + esc(p.kort) + '</span>' : '') +
        '<span class="vcx-del__art">' + esc(p.art) +
          (saknas ? '' : ' <a class="vcx-pdf vcx-prod" href="/products/' + esc(p.handle) + '" target="_blank" rel="noopener">Visa produkt</a>') +
          (p.pdf ? ' <a class="vcx-pdf" href="' + esc(p.pdf) + '" target="_blank" rel="noopener">Monteringsanvisning</a>' : '') +
        '</span>' +
        ik +
      '</span>' +
      '<span class="vcx-del__pris" data-pris>' + (saknas ? 'Kontakta oss' : '&nbsp;') + '</span>' +
    '</label>';
  }

  function rita() {
    if (!state.marke || !state.modell) {
      el.resultat.dataset.open = '0'; el.resultat.innerHTML = ''; steg(0); return;
    }
    if (!state.rad) {
      var r = motorer();
      el.resultat.dataset.open = '1'; steg(1);
      el.resultat.innerHTML = '<div class="vcx-valj"><h3>Vilken motor har bilen?</h3>' +
        '<p>Motorvärmaren sitter i motorblocket, så den är specifik för just din motor. ' +
        'Står motorkoden på registreringsbeviset hittar du den snabbast så.</p>' +
        '<ul class="vcx-motorlista">' + r.map(function (x, n) {
          return '<li><button type="button" data-vcx-motorval="' + n + '">' +
            '<span class="vcx-motorlista__t">' + esc(x[0] || state.modell) + '</span>' +
            '<span class="vcx-motorlista__m">' + (x[1] ? '<span>' + esc(x[1]) + '</span>' : '') +
            (x[2] ? '<span class="kod">' + esc(x[2]) + '</span>' : '') + '</span></button></li>';
        }).join('') + '</ul></div>';
      $$('[data-vcx-motorval]', el.resultat).forEach(function (b) {
        b.addEventListener('click', function () {
          state.rad = r[+b.dataset.vcxMotorval]; state.alt = false; state.tillval = {};
          el.motor.value = b.dataset.vcxMotorval;
          rita();
          root.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      });
      return;
    }

    var rad = state.rad, d = delar(rad), h = '';
    steg(2);
    lankUppdatera();

    h += '<div class="vcx-fordon"><strong>' + esc(state.marke + ' ' + state.modell) + '</strong>' +
      '<span>' + esc(motorTxt(rad)) + '</span>' +
      '<button type="button" class="byt" data-vcx-byt>Ändra fordon</button></div>';

    var ma = montAlt(rad), pl = placering(rad);
    h += '<div class="vcx-fakta">' +
      '<span class="vcx-fakta__tid"><b>Uppskattad monteringstid</b>' +
        '<span data-vcx-tid>\u2013</span></span>' +
      '</div>';

    h += '<div class="vcx-block"><div class="vcx-block__rub"><h3>Ditt system</h3>' +
      '<span class="vcx-markor">Krävs för installation</span></div>' +
      '<p class="vcx-block__not">Delarna nedan utgör ett komplett elsystem för din motor. ' +
      'Avmarkera det du redan har.</p>' +
      '<p class="vcx-komfortnot" data-vcx-komfortnot hidden></p>' +
      '<div class="vcx-delar">' +
      d.map(function (x, n) { return kort(x, 'd' + n, state.tillval['d' + n] !== false, 'Krävs'); }).join('') +
      '</div>';

    if (rad[12]) {
      var annan = produkt(state.alt ? rad[4] : rad[12][0]);
      var nuv = produkt(state.alt ? rad[12][0] : rad[4]);
      if (annan && nuv) {
        h += '<div class="vcx-alt"><p><b>Det finns en alternativ värmare till den här motorn.</b> ' +
          'Du ser nu ' + esc(nuv.titel) + '. Calix anger även ' + esc(annan.titel) + ' som godkänd.</p>' +
          '<button type="button" class="vcx-knapp vcx-knapp--spok" data-vcx-alt>Visa ' + esc(annan.titel) + '</button></div>';
      }
    }
    h += '</div>';

    var komfort = (IX.K || []).map(produkt).filter(Boolean);
    if (komfort.length) {
      h += '<div class="vcx-block"><div class="vcx-block__rub"><h3>Varm kupé också?</h3>' +
        '<span class="vcx-markor vcx-markor--val">Tillval</span></div>' +
        '<p class="vcx-block__not">En komfortsats innehåller värmefläkt för kupén och kablaget som kopplar ihop den med motorvärmaren. ' +
        'Den kan också monteras helt fristående om du bara vill ha varm kupé. ' +
        'Satserna med BC60 eller BC1205 har batteriladdare inbyggd.</p>' +
        '<div class="vcx-delar">' +
        komfort.map(function (p, n) { return kort({ roll: 'Komfortsats', p: p }, 'k' + n, !!state.tillval['k' + n], ''); }).join('') +
        '</div></div>';
    }

    var los = [];
    (IX.T.kupevarmare || []).forEach(function (i) { var p = produkt(i); if (p) los.push({ roll: 'Kupévärmare', p: p }); });
    (IX.T.laddare || []).forEach(function (i) { var p = produkt(i); if (p) los.push({ roll: 'Batteriladdare', p: p }); });
    (IX.T.timer || []).forEach(function (i) { var p = produkt(i); if (p) los.push({ roll: 'Styrning', p: p }); });
    if (los.length) {
      h += '<details class="vcx-mer"><summary>Hellre lösa delar? Visa kupévärmare, laddare och timer var för sig</summary>' +
        '<div class="vcx-delar">' +
        los.map(function (x, n) { return kort(x, 'l' + n, !!state.tillval['l' + n], ''); }).join('') +
        '</div></details>';
    }

    h += '<details class="vcx-verkstad"><summary>F\u00f6r verkstaden</summary>' +
      '<p>Calix referenskoder f\u00f6r just den h\u00e4r motorn. Mont\u00f6ren anv\u00e4nder dem tillsammans med monteringsanvisningen \u2013 som kund beh\u00f6ver du inte t\u00e4nka p\u00e5 dem.</p>' +
      '<div class="vcx-verkstad__rad">' +
        (pl ? '<span><b>Placering</b>' + esc(pl) + '</span>' : '') +
        (ma ? '<span><b>Monteringsprincip</b>' + esc(ma) + '</span>' : '') +
        (TID[rad[3]] ? '<span><b>Calix tidkod</b>' + TID[rad[3]] + '</span>' : '') +
      '</div>' +
      '<p class="vcx-verkstad__not">Calix tidkod avser enligt Calix endast v\u00e4rmaren och intagskabeln. V\u00e5r uppskattning ovan omfattar hela installationen.</p>' +
      '</details>';

    h += '<div class="vcx-summa" data-vcx-summa>' +
      '<div class="vcx-summa__txt"><b data-vcx-antal></b><span data-vcx-lista></span></div>' +
      '<div class="vcx-summa__tot"><span class="lbl">Totalt inkl. moms</span><span class="amt" data-vcx-total>–</span></div>' +
      '<button type="button" class="vcx-knapp vcx-knapp--primar" data-vcx-kop>Lägg allt i varukorgen</button>' +
      '</div>';

    el.resultat.innerHTML = h;
    el.resultat.dataset.open = '1';
    bindResultat();
    ingarIKomfortsats();
    ritaTid();
    priser();
  }

  function bindResultat() {
    var byt = $('[data-vcx-byt]', el.resultat);
    if (byt) byt.addEventListener('click', function () {
      state.rad = null; state.alt = false; state.tillval = {};
      rita(); el.sok.focus();
    });
    var alt = $('[data-vcx-alt]', el.resultat);
    if (alt) alt.addEventListener('click', function () {
      state.alt = !state.alt; state.tillval = {}; rita();
    });
    $$('a.vcx-pdf', el.resultat).forEach(function (a) {
      a.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    $$('[data-vcx-i]', el.resultat).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var rad = b.closest('.vcx-del');
        var k = rad && $('[data-vcx-kort]', rad);
        if (!k) return;
        var pa = k.dataset.open === '1';
        $$('[data-vcx-kort]', el.resultat).forEach(function (x) { x.dataset.open = '0'; });
        k.dataset.open = pa ? '0' : '1';
      });
    });
    $$('[data-vcx-del]', el.resultat).forEach(function (c) {
      c.addEventListener('change', function () {
        state.tillval[c.dataset.vcxDel] = c.checked;
        var rad = c.closest('.vcx-del');
        if (c.checked && rad && rad.classList.contains('vcx-del--ingar')) {
          rad.classList.remove('vcx-del--ingar');
          var m = $('.vcx-ingar', rad); if (m) m.remove();
          var k = $('.vcx-krav', rad); if (k) k.style.display = '';
          rad.dataset.lagdTill = '1';
        }
        if (!c.checked && rad) rad.dataset.lagdTill = '0';
        ingarIKomfortsats();
        summa();
      });
    });
    var kop = $('[data-vcx-kop]', el.resultat);
    if (kop) kop.addEventListener('click', lagg);
  }

  /* ---------- delar som ingar i en vald komfortsats ---------- */
  function ingarIKomfortsats() {
    var tackta = {};
    $$('.vcx-del[data-ersatter]', el.resultat).forEach(function (r) {
      var c = $('input[type=checkbox]', r);
      if (!c || !c.checked || c.disabled) return;
      var namn = $('[data-titel]', r);
      r.dataset.ersatter.split('|').forEach(function (roll) {
        if (roll) tackta[roll] = namn ? namn.textContent : 'komfortsatsen';
      });
    });
    var ruta = $('[data-vcx-komfortnot]', el.resultat);
    if (ruta) {
      var namn = Object.keys(tackta).length ? tackta[Object.keys(tackta)[0]] : '';
      ruta.hidden = !namn;
      if (namn) ruta.textContent = 'Delar som ingår i ' + namn + ' är överstrukna nedan. ' +
        'Behöver bilen längre kabel än den som följer med kan du kryssa i dem igen.';
    }
    $$('.vcx-del[data-roll]', el.resultat).forEach(function (r) {
      var roll = r.dataset.roll || '';
      var c = $('input[type=checkbox]', r);
      var markor = $('.vcx-ingar', r);
      if (tackta[roll] && !r.hasAttribute('data-ersatter') && r.dataset.lagdTill !== '1') {
        if (!r.classList.contains('vcx-del--ingar')) {
          r.dataset.varVald = (c && c.checked) ? '1' : '0';
          if (c) c.checked = false;
          r.classList.add('vcx-del--ingar');
          var roller = $('.vcx-del__roll', r);
          if (roller && !markor) {
            var m = document.createElement('span');
            m.className = 'vcx-ingar';
            m.textContent = 'Ingår i komfortsatsen';
            roller.appendChild(m);
          }
          var krav = $('.vcx-krav', r);
          if (krav) krav.style.display = 'none';
        }
      } else if (r.classList.contains('vcx-del--ingar') && !(c && c.checked)) {
        r.classList.remove('vcx-del--ingar');
        if (c) c.checked = r.dataset.varVald !== '0';
        if (markor) markor.remove();
        var krav2 = $('.vcx-krav', r);
        if (krav2) krav2.style.display = '';
      }
    });
  }

  function priser() {
    $$('[data-handle]', el.resultat).forEach(function (rad) {
      var handle = rad.dataset.handle;
      if (!handle) return;
      hamta(handle).then(function (d) {
        var t = $('[data-titel]', rad), p = $('[data-pris]', rad);
        if (d && t && d.titel) t.textContent = d.titel;
        if (!p) return;
        if (!d) { p.textContent = 'Kontakta oss'; rad.classList.add('vcx-del--saknas'); summa(); return; }
        rad.dataset.variant = d.id || '';
        rad.dataset.ore = d.pris;
        p.innerHTML = kr(d.pris) + (d.finns ? '' : ' <small>(beställningsvara)</small>');
        summa();
      });
    });
  }

  function valda() {
    return $$('[data-handle]', el.resultat).filter(function (r) {
      var c = $('input[type=checkbox]', r);
      return c && c.checked && r.dataset.variant;
    });
  }

  var KRAVS = { 'Motorv\u00e4rmare': 1, 'Monteringssats': 1, 'Anslutningssats': 1, 'Grenledningssats': 1 };

  function timtext(min) {
    function f(m) {
      var t = Math.round((m / 60) * 2) / 2;
      return String(t).replace('.5', ',5');
    }
    var sp = (IX.MT && IX.MT.spann) || 60;
    return 'ca ' + f(min) + '\u2013' + f(min + sp) + ' tim';
  }

  function ritaTid() {
    var ut = $('[data-vcx-tid]', el.resultat);
    if (!ut || !IX.MT || !state.rad) return;
    var mt = IX.MT, grund = 0, extra = 0;
    $$('.vcx-del', el.resultat).forEach(function (r) {
      var c = $('input[type=checkbox]', r);
      if (!c || !c.checked || c.disabled) return;
      var roll = r.dataset.roll || '';
      if (KRAVS[roll]) grund = 1;
      if (mt.del[roll]) extra += mt.del[roll];
    });
    var bas = grund ? (mt.bas[String(state.rad[3])] || mt.standard) : 0;
    var min = bas + extra;
    ut.textContent = min > 0 ? timtext(min) : '\u2013';
  }

  function summa() {
    var box = $('[data-vcx-summa]', el.resultat);
    if (!box) return;
    ritaTid();
    var v = valda(), tot = 0, namn = [], klar = v.length > 0;
    v.forEach(function (r) {
      var o = parseInt(r.dataset.ore, 10);
      if (isNaN(o)) klar = false; else tot += o;
      var t = $('[data-titel]', r);
      namn.push(t ? t.textContent : '');
    });
    $('[data-vcx-antal]', box).textContent = v.length ? 'Ditt paket: ' + v.length + ' delar' : 'Välj minst en del';
    $('[data-vcx-lista]', box).textContent = namn.join(' + ');
    $('[data-vcx-total]', box).textContent = klar ? kr(tot) : '–';
    $('[data-vcx-kop]', box).disabled = !klar;
  }

  function lagg() {
    var knapp = $('[data-vcx-kop]', el.resultat);
    var rader = valda().map(function (r) { return { id: +r.dataset.variant, quantity: 1 }; });
    if (!rader.length) return;
    knapp.disabled = true; knapp.textContent = 'Lägger till …';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: rader })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      window.location.href = '/cart';
    }).catch(function () {
      knapp.disabled = false; knapp.textContent = 'Kunde inte läggas till – försök igen';
    });
  }

  /* ---------- länk till valt fordon ---------- */
  function lankUppdatera() {
    if (!state.marke) return;
    var d = [state.marke, state.modell, state.rad ? state.rad[0] : '', state.rad ? state.rad[2] : ''];
    history.replaceState(null, '', '#bil=' + encodeURIComponent(d.join('|')));
  }
  function frånLank() {
    var m = /#bil=([^&]+)/.exec(location.hash);
    if (!m) return;
    var d = decodeURIComponent(m[1]).split('|');
    state.marke = d[0] || ''; state.modell = d[1] || '';
    if (!IX.B[state.marke]) { state.marke = ''; return; }
    el.marke.value = state.marke; fyllModeller();
    if (state.modell && (IX.B[state.marke] || {})[state.modell]) {
      el.modell.value = state.modell; fyllMotorer();
      var r = motorer();
      for (var i = 0; i < r.length; i++) {
        if (r[i][0] === d[2] && (r[i][2] || '') === (d[3] || '')) { state.rad = r[i]; el.motor.value = i; break; }
      }
    } else { state.modell = ''; }
    el.sok.value = state.marke + (state.modell ? ' ' + state.modell : '');
    el.rensa.style.display = '';
    rita();
  }
})();
